import classNames from "classnames";
import { type HTMLAttributes, type ReactNode } from "react";
import useTranslation from "../../utils/hooks/useTranslation";

 // @ts-ignore
interface TextProps extends HTMLAttributes<any> {
  isName?: boolean;
  accent?: boolean;
  children?: string | ReactNode;
  className?: string;
  contenteditable?: boolean;
  dataHeading?: boolean;
  dataShrink?: string;
  dataSize?: string;
  dataWeight?: string;
  digit?: boolean;
  error?: boolean;
  ellipsis?: boolean;
  highlight?: boolean;
  large?: boolean;
  light?: boolean;
  medium?: boolean;
  middle?: boolean;
  nowrap?: boolean;
  private?: boolean;
  space?: boolean;
  wrap?: boolean;
  wrapLine?: boolean;
  translate?: boolean;
  translateArgs?: Record<string, string | number>;
}

export const Text: React.FC<TextProps> = ({
  isName = false,
  accent = false,
  children = "",
  className = "",
  contenteditable = false,
  dataHeading,
  dataShrink,
  dataSize,
  dataWeight = "",
  digit = false,
  error = false,
  ellipsis = false,
  highlight = false,
  large = false,
  light = false,
  medium = false,
  middle = false,
  nowrap = false,
  //private = false,    reserved word in strict mode
  space = false,
  wrap = false,
  wrapLine = false,
  //   translateArgs,
  translate = false,
  ...rest
}) => {
  const { t } = useTranslation();
  const props: any = {};

  accent && (props.accent = "");
  contenteditable && (props.contenteditable = contenteditable);
  dataHeading && (props["data-heading"] = "");
  dataSize && (props["data-size"] = dataSize);
  dataShrink && (props["data-shrink"] = dataShrink);
  dataWeight && (props["data-weight"] = dataWeight);
  digit && (props.digit = digit);
  error && (props.error = error);
  highlight && (props.highlight = highlight);
  large && (props.large = large);
  medium && (props.medium = medium);
  middle && (props.middle = middle);
  nowrap && (props.nowrap = nowrap);
  light && (props.light = "");
  ellipsis && (props.ellipsis = "");
  space && (props.space = "");
  wrap && (props.wrap = "");
  wrapLine && (props["wrap-line"] = wrapLine);

  return (
    <text className={classNames(className)} {...props} {...rest}>
      {/* {isName || typeof children !== 'string' ? children : t(children, translateArgs)} */}
      {isName || typeof children !== "string" ? children : (translate ? t(children) : children)}
    </text>
  );
};
